export function initStarRating(containerSelector = "#star-rating") {
  const container = document.querySelector(containerSelector);
  if (!container) return;

  const stars = container.querySelectorAll(".star-label i");
  const inputs = container.querySelectorAll('input[name="score"]');

  function updateStars(selectedValue) {
    const value = parseInt(selectedValue);
    stars.forEach((star, index) => {
      if (index < value) {
        star.classList.remove("fa-regular");
        star.classList.add("fa-solid");
      } else {
        star.classList.remove("fa-solid");
        star.classList.add("fa-regular");
      }
    });
  }

  function getSelectedValue() {
    const checked = container.querySelector('input[name="score"]:checked');
    return checked ? parseInt(checked.value) : 0;
  }

  // Update on click (change)
  inputs.forEach((input) => {
    input.addEventListener("change", () => {
      updateStars(input.value);
    });
  });

  // Add hover preview behavior
  stars.forEach((star, index) => {
    // Hover in
    star.addEventListener("mouseenter", () => {
      updateStars(index + 1);
    });

    // Hover out: revert to selected
    star.addEventListener("mouseleave", () => {
      updateStars(getSelectedValue());
    });
  });

  // Initialize on load
  updateStars(getSelectedValue());
}
